import styled from 'styled-components';

const SubServicesStyle = styled.div`
	&.we_offer_wrapper {
		--weOfferDescWidth: 100%;
		--weOfferDescPaddingBottom: var(--sp7x);

		.offerDescWrapper {
			padding-bottom: var(--weOfferDescPaddingBottom);
			border-bottom: 2px solid var(--black);

			.we_offer_desc {
				max-width: var(--weOfferDescWidth);
			}
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		&.we_offer_wrapper {
			--weOfferDescWidth: 78vw;
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
		&.we_offer_wrapper {
			--weOfferDescWidth: 73vw;
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) {
		&.we_offer_wrapper {
			--weOfferDescWidth: 73vw;
			--weOfferDescPaddingBottom: var(--sp10x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) {
		&.we_offer_wrapper {
			--weOfferDescWidth: 78vw;
			--weOfferDescPaddingBottom: var(--sp12x);
		}
	}

	@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
		&.we_offer_wrapper {
			--weOfferDescWidth: 60vw;
			--weOfferDescPaddingBottom: var(--sp15x);
		}
	}
`;

export default SubServicesStyle;
